import { ensureModuleMessages, registerModuleCatalog } from '@/shared/i18n/i18n';
import type { Locale } from '@/shared/i18n/locales';

import type * as Api from './communication-setting.api';

// Porta do módulo (U06). Entra no JS inicial (src/app/screens.ts e a rota): só o manifesto, o schema de
// busca e funções que carregam o resto por `import()`. A tela, o fio e as queries ficam em chunks próprios.

export {
  COMMUNICATION_SETTING_PATH,
  communicationSettingListScreen,
} from './communication-setting.screen';
export {
  communicationSettingSearch,
  type CommunicationSettingSearch,
} from './communication-setting.search';
export { communicationSettingSource } from './communication-setting.options';
export type {
  CommunicationSetting,
  CommunicationSettingOption,
} from './communication-setting.wire';

const MODULE = 'communication-setting';

// `eager`: títulos do manifesto no ⌘K e no breadcrumb antes de a tela abrir (A07, revisão B2).
registerModuleCatalog(MODULE, (locale: Locale) => import(`./locales/${locale}.po`), {
  eager: true,
});

/** Carrega o catálogo do módulo no idioma ativo (a rota chama antes de desenhar a tela). */
export function loadCommunicationSettingMessages(): Promise<void> {
  return ensureModuleMessages(MODULE);
}

/** A tela da rota (`CommunicationSettingRouteScreen`), por `lazyScreen`. */
export const loadCommunicationSettingScreen = () => import('./communication-setting.page');

/** Creation form embedded by flows that also choose a communication rule. */
export const loadCommunicationSettingSheet = () => import('./communication-setting-sheet');

/**
 * Porta de busca de régua de comunicação para outros módulos (Cessionário, Parcelamento; F0): o mesmo
 * `GET /CommunicationSetting` do autocomplete do legado. Carrega o fio sob demanda.
 */
export async function listCommunicationSettingOptions(
  ...args: Parameters<typeof Api.listCommunicationSettingOptions>
) {
  return (await import('./communication-setting.api')).listCommunicationSettingOptions(...args);
}

/** `GET /CommunicationSetting/{id}` (o Cessionário mostra a régua escolhida). */
export async function getCommunicationSetting(
  ...args: Parameters<typeof Api.getCommunicationSetting>
) {
  return (await import('./communication-setting.api')).getCommunicationSetting(...args);
}

export {
  communicationSettingOptionsQuery,
  communicationSettingQuery,
} from './communication-setting.queries';
